import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../../../component/form/Grid';
import PrimaryButton, { DestroyButton, OutlineButton } from '../../../../component/form/PrimaryButton';
import { InlineFieldRightAlignChildren } from '../../../../component/form/Inline';
import BillTo, { BILL_TO_MAPPING } from '../BillTo';
import ModalStepTitle from '../../../../component/form/ModalStepTitle';
import { DialogActions } from '@mui/material';
import { isNullOrUndefined } from '../../../../util/objects';
import { CloseIcon, DeleteIcon, NextIcon } from '../../../../component/IconIndex';

class BillingDetailsTab extends Component {
    state = {
        billToMapping: {},
        invoiceIndex: -1
    };

    static getDerivedStateFromProps({ invoiceIndex, form }, state) {
        if (invoiceIndex !== state.invoiceIndex) {
            return { invoiceIndex, billToMapping: createBillToMapping() };
        }
        return null;
    }

    render() {
        const { classes, nextTab, onCancel, loading, canEdit, onSubmit, form, parentForm } = this.props;
        const { billToMapping } = this.state;
        if (isNullOrUndefined(form)) return null;
        const isSaved = form.getField('ID') > 0;
        const hasXero = !!form.getField('XeroID');
        return (
            <Fragment>
                <Grid container spacing={2} className={classes.root}>
                    <ModalStepTitle number={this.props.stepNumber} title="Please confirm the billing details" />

                    <Grid container spacing={2} className={classes.billToWrapper}>
                        <Grid bucket>
                            <BillTo billingTargetForm={form} billingSourceForm={parentForm} mapping={billToMapping} />
                        </Grid>
                    </Grid>
                </Grid>
                <DialogActions className={classes.modalFooter}>
                    <InlineFieldRightAlignChildren lineHeight={'normal'}>
                        <span>
                            <OutlineButton onClick={loading ? undefined : onCancel} color="primary" disabled={loading}>
                                <CloseIcon />
                                <span className={classes.svgLabel}>Cancel</span>
                            </OutlineButton>
                        </span>
                        {isSaved && !hasXero && (
                            <DestroyButton
                                disabled={!canEdit || loading}
                                onClick={() => {
                                    if (window.confirm('Are you sure you want to discard this?')) {
                                        form.setField({ Archived: true });
                                        onSubmit();
                                        setTimeout(() => onCancel(), 50);
                                    }
                                }}
                            >
                                <DeleteIcon />
                                <span className={classes.svgLabel}>Delete</span>
                            </DestroyButton>
                        )}
                        <PrimaryButton onClick={nextTab} disabled={loading}>
                            <span className={classes.svgLabel}>Next Step</span>
                            <NextIcon />
                        </PrimaryButton>
                    </InlineFieldRightAlignChildren>
                </DialogActions>
            </Fragment>
        );
    }
}

const createBillToMapping = () => {
    return {
        [BILL_TO_MAPPING.billingSource]: `Customer.BillingSource`,
        [BILL_TO_MAPPING.relationToDeceased]: `Customer.RelationToDeceased`,
        [BILL_TO_MAPPING.givenName]: `Customer.FirstName`,
        [BILL_TO_MAPPING.middleName]: `Customer.MiddleName`,
        [BILL_TO_MAPPING.surname]: `Customer.Surname`,
        [BILL_TO_MAPPING.fullName]: `Customer.CustomerName`,
        [BILL_TO_MAPPING.phones]: `Customer.Phones`,
        [BILL_TO_MAPPING.line1]: `Customer.AddressLine1`,
        [BILL_TO_MAPPING.line2]: `Customer.AddressLine2`,
        [BILL_TO_MAPPING.city]: `Customer.Suburb`,
        [BILL_TO_MAPPING.state]: `Customer.State`,
        [BILL_TO_MAPPING.country]: `Customer.Country`,
        [BILL_TO_MAPPING.code]: `Customer.Postcode`,
        [BILL_TO_MAPPING.email]: `Customer.Email`,
        [BILL_TO_MAPPING.billingId]: `Customer.BillingId`
    };
};

export const convertToCustomer = billTo => {
    return {
        AddressLine1: billTo.AddressLine1,
        AddressLine2: billTo.AddressLine2,
        Suburb: billTo.Suburb,
        State: billTo.State,
        Postcode: billTo.Postcode,
        BillingId: billTo.BillingId,
        Country: billTo.Country,
        Phones: (billTo.Phones || []).map((phone, index) => ({
            Number: phone.Number,
            Type: phone.Type || null,
            Comment: phone.Comment || null,
            Sort: index
        })),
        Contact: billTo.Contact,
        FirstName: billTo.FirstName,
        MiddleName: billTo.MiddleName,
        Surname: billTo.Surname,
        CustomerName: billTo.Name,
        BillingSource: billTo.BillingSource,
        RelationToDeceased: billTo.RelationToDeceased,
        Email: billTo.Email
    };
};

const styles = ({ breakpoints, spacing }) => ({
    root: {
        margin: '0',
        padding: '50px 30px 30px 30px',
        height: 'auto',
        alignContent: 'start',
        flexDirection: 'column',
        justifyContent: 'space-between',
        display: 'flex',
        width: '100%',
        [breakpoints.down('sm')]: {
            padding: spacing(1)
        }
    },

    billToWrapper: {
        width: '100%',
        display: 'block',
        height: 450 /* room for autocomplete dropdown*/,
        [breakpoints.down('sm')]: {
            margin: 0
        }
    },

    alignWithFloatingLabel: {
        marginTop: 17
    },

    alignWithLabel: {
        marginTop: 10
    }
});

export default withStyles(styles)(BillingDetailsTab);
